export const TAILWIND_XS = 465;
export const TAILWIND_SM = 640;
export const TAILWIND_MD = 768;
export const TAILWIND_LG = 1024;
export const TAILWIND_XL = 1280;
export const TAILWIND_XXL = 1536;
